<template>
    <div class="FEwrapper" :class="{scaleFE: options.scaleFE}">
        <Toolbar v-if="!options.isWebView" :color="getHouseColor" :languageStrings="languageStrings" :options="options"></Toolbar>
        <Advertising :store="store" :options="options"></Advertising>
        <router-view :store="store" :location="location" :languageStrings="languageStrings" :options="options" :houseColors="houseColors" :key="$route.fullPath" :currentLanguage="currentLanguage"></router-view>
        <div v-if="!options.isWebView" id="nav">
            <router-link :to="{name: 'Home'}"> <svg xmlns="http://www.w3.org/2000/svg" width="27.193" height="22.676" viewBox="0 0 27.193 22.676">
                <g id="Group_48" data-name="Group 48" transform="translate(-60.815 -384.243)" style="isolation: isolate">
                    <path id="Path_97" data-name="Path 97" d="M62.226,395.841l12.151-10.6,12.22,10.6" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Path_98" data-name="Path 98" d="M83.852,394.677v12.862h-6.44v-5.652H72.872v5.652h-6.44V394.56" transform="translate(-0.731 -1.62)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="2"/>
                </g>
            </svg>
                Home</router-link>
            <router-link :to="{name: 'ShopFinder'}" :class="{'router-link-exact-active': ( $route.name.indexOf('Shop') > -1 ) }">
                <svg xmlns="http://www.w3.org/2000/svg" width="21.348" height="14.594" viewBox="0 0 21.348 14.594">
                    <g id="Group_30" data-name="Group 30" transform="translate(-60.445 -497.509)" style="isolation: isolate">
                        <line id="Line_29" data-name="Line 29" x1="19.348" transform="translate(61.445 498.509)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <line id="Line_30" data-name="Line 30" x1="19.348" transform="translate(61.445 504.806)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <line id="Line_31" data-name="Line 31" x1="12.955" transform="translate(61.445 511.103)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    </g>
                </svg> shops
            </router-link>
            <router-link :to="{name: 'Search'}" >
                <svg xmlns="http://www.w3.org/2000/svg" width="19.006" height="18.856" viewBox="0 0 19.006 18.856">
                    <g id="Group_24" data-name="Group 24" transform="translate(-218.918 -401.133)">
                        <path id="Path_89" data-name="Path 89" d="M233.683,409.016a6.882,6.882,0,1,1-6.883-6.883A6.882,6.882,0,0,1,233.683,409.016Z" fill="rgba(0,0,0,0)" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <line id="Line_26" data-name="Line 26" x2="4.715" y2="4.671" transform="translate(231.795 413.903)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    </g>
                </svg>{{languageStrings.suche}}</router-link>
            <div v-if="!options.isDetailView" class="lang-switch" :class="{'open':isLangDropOpen}" >
                <div class="drop">
                    <a v-for="lang in otherLanguages" :class="{'active': lang.code == currentLanguage }" @click="$emit('changeLang', lang.code), isLangDropOpen = false"><img src="@/assets/globeicon.svg" >{{lang.name}}</a>
                </div>
                <div class="current btn" @click="isLangDropOpen = !isLangDropOpen">
                    <img src="@/assets/globeicon.svg" >{{languageStrings[currentLanguage]}}
                </div>
            </div>
        </div>
        <DebugBar v-if="options.debug" :store="store" :location="location" :options="options"></DebugBar>
    </div>
</template>
<script>
    import Toolbar from '@/components/Toolbar.vue';
    import router from '@/router'
    import * as language from '@/translations'
    import Advertising from "@/components/Advertising";
    import DebugBar from "@/components/DebugBar.vue";

    export default {
        name: 'Frontend',
        data() {
            return {
                timestring: '',
                datestring: '',
                location: {
                    house: 1, level: 2
                },
                language: language,
                isLangDropOpen: false,
            }
        },
        components: {
            DebugBar,
            Advertising,
            Toolbar
        },
        props: ['store', 'options', 'currentLanguage', 'houseColors'],
        created() {
            this.setDate()
            let url = new URL(window.location.href);
            let location = url.searchParams.get('location');
            if ( location ){
                this.location = this.locations.find(x=> x.id == location);
            }
        },
        mounted() {
            document.getElementById('app').addEventListener('click', function () {
                resetTimer();
            });
            window.theTimer = setTimeout(function () {
                reset()
            }, 5000)
            function resetTimer() {
                clearTimeout(window.theTimer);
                window.theTimer = setTimeout(function () {
                    reset()
                }, 30000)
            }
            function reset() {
                router
            }
        },
        computed: {
            getHouseColor(){
                let house = this.options.location.substr(2,1);
                return this.houseColors.find(x=> x.id == house).color
            },
            otherLanguages(){
                return this.language.languages.filter(x=> x.code != this.currentLanguage)
            },
            languageStrings(){
                return this.language.strings[this.currentLanguage];
            }
        },
        methods: {
            setDate(){
                var now = new Date();
                var datestring = now.toLocaleDateString('de-DE', {weekday: 'short'}) + ', ' + now.toLocaleDateString('de-DE', {day: 'numeric'}) + '. ' + now.toLocaleDateString('de-DE', {month: 'long'});
                this.datestring = datestring;
                var mins = now.getMinutes();
                var timestring = now.getHours() + ':' + (mins > 9 ? mins : '0' + mins);
                this.timestring = timestring;
            },
            startTimer(){

            },
            setLanguage(lang){
                this.currentLanguage = lang;
                this.isLangDropOpen = false;

            }
        }

    }

</script>

<style lang="scss">

    @import "@/styles/variables";

    * {
        box-sizing: border-box;
    }

    .FEwrapper {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        position: relative;
        height: 100vh;
        width: 100vw;
        overflow: hidden;
        padding-top: 80px;
        padding-bottom: 120px;
        display: flex;
        transform-origin: top left;
        background: white;

        &.scaleFE {
            width: 1920px;
            height: 1080px;
            transform: scale(0.6);
          @include portrait(){
            width: auto;
            height: 100vh;
            transform: scale(1);
          }
        }
    }

    .ShopDetails {
        .advertising {
            display: none !important;
        }
    }

    #app.webview {
        background: white;
        //width: 1152px;
        //height: 650px;
        overflow: hidden;
        .FEwrapper {
            /*transform: scale(0.6);*/
            /*width: auto;*/
            /*height: auto;*/
        }
    }

    #nav {
        position: fixed;
        bottom: 0px;
        border-top: 2px solid $orange;
        height: 120px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        background: white;
        z-index: 10;

        @include portrait(){
            transform: scale(1.4);
        }

        a {
            font-weight: bold;
            width: 169px;
            height: 50px;
            background: $orange;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50px;
            text-transform: uppercase;
            text-decoration: none;
            margin: 0px 10px;

            @include buttonActive;

            svg {
                margin-right: 18px;
            }

            &.router-link-exact-active {
                background: white;
                color: $orange;
                border: 2px solid $orange;

                svg {
                    line, path {
                        stroke: $orange
                    }

                }

            }
        }

        .lang-switch{
            position: absolute;
            right: 100px;
            bottom: 35px;
            cursor: pointer;

            a, .btn {
                border-radius: 30px;
                border: 2px solid $orange;
                width: 169px;
                color:  $orange;
                min-height: 50px;
                background: white;
                display: flex;
                align-items: center;
                margin: 0;
                margin-top: 10px;
                justify-content: flex-start;
                font-weight: 700;
                /*justify-content: center;*/

            }

            @include portrait(){
                position: relative;
                bottom: 35px;
                right: 0;
                margin: 0 10px;
            }

            img {
                margin-left: 20px;
                margin-bottom: 12px;
                position: relative;
                left: 0;
                top:6px;
                margin-right: 10px;
            }


            .drop {
                /*display: none;*/
                position: relative;
                transition: all 0.3s ease;
                opacity: 0;
                visibility: hidden;
                position: relative;
                top: -20px;
            }

            &.open {
                .drop {
                    visibility: visible;
                    opacity: 1;
                    top: 0;
                }
            }
        }
    }


</style>